import React from 'react'
import Card from '../../../components/card'
import { withRouter } from 'react-router-dom'

import * as popUp from '../../../components/toastr'

import { Button } from 'primereact/button'
import { InputNumber } from 'primereact/inputnumber'
import { addLocale } from 'primereact/api'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { AuthContext } from '../../../main/authProvider'
import HandleErrorService from '../../../app/service/handleErrorService'
import GeneralServices from '../../../app/service/generalServices'
import LancamentoFechamentoCaixaService from '../../../app/service/contasAReceber/lancamentoFechamentoCaixaService'
import PDVLancamentoService from '../../../app/service/contasAReceber/pdvLancamentoService'
import SelectMenu from '../../../components/selectMenu'
import PDVCaixaService from '../../../app/service/contasAReceber/pdvCaixaService'
import CustomCalendar from '../../../components/calendar/customCalendar'
import PDVCaixaInput from '../../../components/pdvCaixa/pdvCaixaInput'
import ConstantsUtil from '../../../context/constantsUtil'
import CustomHighlighter from '../../../components/customHighlighter'
import TooltipButton from '../../../components/tooltipButton'
import { Dialog } from 'primereact/dialog'
import FileUploadCard from '../../../components/fileUploadCard'
import AuthService from '../../../app/service/authService'
import AnotacoesComponent from '../../../components/anotacoesComponent'

class LancarFechamentoDeCaixa extends React.Component {


    constructor(){
        super();
        this.lancamentoFechamentoCaixaService = new LancamentoFechamentoCaixaService();
        this.pdvCaixaService = new PDVCaixaService()
        this.pdvLancamentoService = new PDVLancamentoService();
        this.generalServices = new GeneralServices();
        this.pdvCaixaInputRef = React.createRef()
    }

    state = {

        dataLancamento: '',
        dataLancamentoView: '',
        inputDateErrorClass:'',
        errorDateMessage:'',

        lancamentosFromServer: [], //não deve ser alterado pelo front
        lancamentos: null,
        lancamentoImporatadoTipoDeRecebimentoMap: null,
        isDoingLancamentos: false,
        isSavingLancamentos: false,
        savedCompleted: false,
        loading: false,
        totalLancado: 0,

        pdvLancamentoFromServer: null,
        pdvLancamento: null, //ponto de venda

        pdvCaixaList: [],

        selectedPdvCaixaId: '',
        inputPdvCaixaErrorClass: '',

        selectedTurno: '',
        inputTurnoErrorClass: '',

        searchText: '',

        displayImportacaoDialog: false,

        // reprocessing: false,

    }

    componentDidMount(){
        this.searchPdvCaixa()
    }

    searchPdvCaixa = () => {
        this.pdvCaixaService.search()
        .then(response => {
            this.setState({pdvCaixaList: this.lancamentoFechamentoCaixaService.formatArray(response.data) })
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }
    
    handlePdvLancamentoChange = async (event) => {
        let value = event.value
        if(value === 0){
            value = null
        }
        const name = event.target.name
        await this.setState({ [name]: value })
    }

    handleDateChange = async (event) => {
        const value = event.target.value
        const name = event.target.name
        await this.setState({ [name]: GeneralServices.convertJSDateToBrDate(value) })
        const nameView = name+"View"
        await this.setState({[nameView]: value })
        
    }

    handleTableChange = async (event, rowData) => {
        var array = this.state.lancamentos
        var lancamento = array[array.indexOf(rowData)]
        var valor = event.value

        if(isNaN(valor)){ //acontece quando usuário apaga um valor que havia inicialmente
            valor = 0
        }
        valor = parseFloat(valor)

        if(valor === 0){
            valor = null
        }

        //Por referência, alterar o obj lancamento já vai alterar dentro de array
        lancamento.valor = valor
        lancamento.dataLancamento = this.state.dataLancamento
        var valorOriginal = this.state.lancamentosFromServer.find(element => element.idTipoDeRecebimento === lancamento.idTipoDeRecebimento).valor
        lancamento.lancamentoJaRealizado = valor !== valorOriginal
        
        await this.setState({lancamentos: array})
        this.calculateTotalLancado()
    }

    filterLancamentos = () => {
        if(this.state.searchText){
            return this.state.lancamentos.filter(lancamento => GeneralServices.includeString
                (
                    lancamento.nomeTipoDeRecebimento, this.state.searchText
                )
            )
        }

        return this.state.lancamentos
    }

    handleNavigatorDateChange = (event, e) => {
        e.onChange(event.originalEvent, event.value)
    }

    // preencheLancamentosImportados = () => {

    //     let lancamentos = this.state.lancamentos
        
    //     lancamentos.forEach(lancamento => {
    //         if(!lancamento.valor){
    //             let lancamentoImportacao = this.state.lancamentoImporatadoTipoDeRecebimentoMap[lancamento.idTipoDeRecebimento]
    //             if(lancamentoImportacao){
    //                 lancamento.idLancamentoImportacao = lancamentoImportacao.idLancamentoImportacao
    //                 this.handleTableChange({value: lancamentoImportacao.valor}, lancamento)
    //             }
    //         }
    //     })

    //     this.setState({lancamentos})

    // }

    searchLancamentoTipoDeRecebimento = async () => {

        this.setState({loading: true})

        this.lancamentoFechamentoCaixaService.getLancamentos(this.state.dataLancamento, this.state.selectedPdvCaixaId, this.state.selectedTurno)
        .then(async response => {
            await this.setState({lancamentos: response.data.lancamentos})
            await this.setState({lancamentoImporatadoTipoDeRecebimentoMap: response.data.lancamentoImporatadoTipoDeRecebimentoMap})
            await this.setState({lancamentosFromServer: JSON.parse(JSON.stringify(response.data.lancamentos))}) //copiar sem referência
            
            // this.preencheLancamentosImportados()

            this.calculateTotalLancado()
        

            // this.setState({loading: true})
            // await this.generalServices.sleep(500)
            // this.setState({loading: false})

        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loading: false})
            this.setState({isSavingLancamentos: false})
        })
    }

    searchPDVLancamento = async () => {
        this.pdvLancamentoService.getPDV(this.state.dataLancamento, this.state.selectedPdvCaixaId, this.state.selectedTurno)
        .then(async response => {
            var pdvLancamentoFromServer =  JSON.parse(JSON.stringify(response.data))
            if(pdvLancamentoFromServer.lancamentoJaRealizado){
                this.setState({pdvLancamentoFromServer: JSON.parse(JSON.stringify(pdvLancamentoFromServer))})
                const valor = pdvLancamentoFromServer.valor !== 0 ? pdvLancamentoFromServer.valor : null
                this.setState({pdvLancamento: valor})
            }
            else {
                this.setState({pdvLancamentoFromServer: {lancamentoJaRealizado: false}})
            }
        }).catch(error => {
            HandleErrorService.handleError(error)
            this.setState({isSavingLancamentos: false})
        })
    }

    handleChange =  async (event) => {
        const value = event.target.value
        const name = event.target.name
        await this.setState({[name]: value})
    }

    search = async () => {
        if(AuthService.getPerfil().isOperadorCego){
            this.setState({pdvLancamentoFromServer: {lancamentoJaRealizado: false}}) 
        }
        else{
            await this.searchPDVLancamento()
        }
        this.searchLancamentoTipoDeRecebimento()
    }

    resetView = () => {
        this.setState({inputDateErrorClass: ''})
        this.setState({errorDateMessage: ''})

        this.setState({inputPdvCaixaErrorClass: ''})
        this.setState({inputTurnoErrorClass: ''})


        this.setState({savedCompleted: false})
        this.setState({pdvLancamento: null})
    }

    checkData = () => {
        var check = true

        if(!this.state.dataLancamento){
            this.setState({inputDateErrorClass: "p-invalid"})
            this.setState({errorDateMessage: "Informe a data"})
            check = false
        }
        if(!this.state.selectedPdvCaixaId){
            this.setState({inputPdvCaixaErrorClass: "is-invalid"})
            check = false
        }

        if(!this.state.selectedTurno){
            this.setState({inputTurnoErrorClass: "is-invalid"})
            check = false
        }

        return check
    }

    callLancamento = async () => {
        this.resetView()
        if(this.checkData()){
            await this.search()
            this.setState({isDoingLancamentos: true})
        }
    }


    cancelLancamentoLine = (lancamento) => {

        var auxArray = this.state.lancamentos
        const index = auxArray.indexOf(lancamento)

        let novoLancamento = null

        if(lancamento.idLancamentoImportacao){
            //Significa que não possui valor salvo. Está apresentando o valor da importação.
            lancamento.valor = 0.0
            lancamento.lancamentoJaRealizado = false
            lancamento.idLancamentoImportacao = null
            novoLancamento = JSON.parse(JSON.stringify(lancamento))
        }
        else{
            var originalLancamento = this.state.lancamentosFromServer.find(element => element.idTipoDeRecebimento === lancamento.idTipoDeRecebimento)
            novoLancamento = JSON.parse(JSON.stringify(originalLancamento))
        }


        auxArray[index] = JSON.parse(JSON.stringify(novoLancamento))
        
        this.setState({lancamentos: auxArray})

        //voltar o total lançado ao valor inicial também
        this.calculateTotalLancado()

    }

    cancelLacamentos = () => {
        this.setState({isDoingLancamentos: false})
        this.setState({lancamentos: null})
        this.setState({pdvLancamento: ""})
        this.setState({searchText: ''})
    }

    saveLancamentos = () => {

        this.setState({isSavingLancamentos: true})
        this.setState({loading: true})

        this.lancamentoFechamentoCaixaService.save({
            lancamentosList: this.state.lancamentos,
            /*
                dataLancamento, pdvCaixaId e turno são os mesmos para todos os lançamentos,
                uma vez que o usuário define caixa e turno que está lançando.
            */
            dataLancamento: this.state.dataLancamento,
            pdvCaixaId: this.state.selectedPdvCaixaId,
            turno: this.state.selectedTurno
        })
        .then(async response => {
            popUp.successPopUp("Lançamentos salvos com sucesso.")
            this.setState({isDoingLancamentos: false})
            this.setState({lancamentos: null})
            await this.search()
            this.setState({savedCompleted: true})
            // this.setState({dataLancamento: ''})
            // this.setState({dataLancamentoView: ''})
            // this.setState({selectedPdvCaixaId: ''})
            // this.setState({selectedTurno: ''})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
            this.setState({isSavingLancamentos: false})
        })
        .finally(() => {
            this.setState({loading: false})
        })
    }

    savePdvLancamento = () => {
        if(this.state.pdvLancamentoFromServer.lancamentoJaRealizado || this.state.pdvLancamento){
            this.pdvLancamentoService.save({
                dataLancamento: this.state.dataLancamento,
                pdvCaixaId: this.state.selectedPdvCaixaId,
                turno: this.state.selectedTurno,
                valor: this.state.pdvLancamento,
                lancamentoJaRealizado: true
            }).then(async response => {
                this.setState({pdvLancamento: ""})
            }).catch(error => {
                HandleErrorService.handleError(error)
                this.setState({isSavingLancamentos: false})
            })
        }
    }

    save = () => {
        this.savePdvLancamento()
        this.saveLancamentos()
    }

    calculateTotalLancado = () => {
        if(!this.state.lancamentos)
        return
        var sum = 0
        this.state.lancamentos.forEach(element => {

        if( !isNaN(element.valor) && element.valor){
            /*
                Não deve somar se for NaN, se for 0 ou se não tiver valor (null).
                OBS: Fica NaN qnd o usuário apaga um valor já lançado, por exemplo.
            */
            sum += element.valor
        }

        })
        this.setState({totalLancado: sum})
    }

    calculateDiferenca = () => {
        var pdvLancamento = this.state.pdvLancamento!==null ? this.state.pdvLancamento : 0
        var dif = this.state.totalLancado - pdvLancamento
        return dif
    }

    getClassNameButtonDiferenca = () => {
        if(this.calculateDiferenca() < 0){
            return "p-button-danger"
        }
        return "p-button-primary"
    }    

    onLostFocus = () => {
        // this.setState({searchText: ''})
    }

    limparPesquisa = () => {
        this.setState({searchText: ''})
    }

    onKeyDown = async (event) => {
        /*
            Essa função é chamada no mesmo instante que a handleValorChange.
            Precisa esperar um tempo de forma que o valor seja alterado.
        */
        await this.generalServices.sleep(1)
        
        if (event.key === "Enter") {
            this.onLostFocus();
        }
        
    }

    situacaoInicial =() => {
        return !this.state.isDoingLancamentos || this.state.savedCompleted
    }

    hideDialog = () => {
        this.setState({displayImportacaoDialog: false})
    }

    getNomeSelectedCaixa = () => {
        let pdvCaixaList = this.pdvCaixaInputRef.current.state.pdvCaixaList
        let pdvCaixaSelecionado = pdvCaixaList.find(pdvCaixa => pdvCaixa.value == this.state.selectedPdvCaixaId)
        return pdvCaixaSelecionado.label
    }

    montaRecursoAnotacao = () => {

        let recurso = {
            nome: `${this.state.selectedPdvCaixaId}#${this.state.selectedTurno}`, //caixaId#Truno
            nomeTratado: `${this.getNomeSelectedCaixa()} - ${this.state.selectedTurno}`,
            data: this.state.dataLancamento,
            tipo: ConstantsUtil.lancamentoFechamentoCaixaRecurso,
        }

        // console.log("recurso: ", recurso)

        return recurso        
    }

    copyValue = (valor) => {
        GeneralServices.onClickCopyValueFunction(valor, "Valor copiado!", true)
    }

    render() {

        addLocale('pt-BR', {
            firstDayOfWeek: 0,
            dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
            dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
            dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
            monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
            monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
            today: 'Hoje',
            clear: 'Limpar'
        })

        // const valueEditor = (options) => {
        //     return <InputNumber
        //                 id={options.rowData.idTipoDeRecebimento}
        //                 name={options.rowData.nomeTipoDeRecebimento}
        //                 placeholder='Informe o valor'
        //                 value={options.rowData.valor}
        //                 mode="decimal"
        //                 minFractionDigits={2} maxFracionDigits={2}
        //                 onValueChange={(event) => this.handleTableChange(event, options.rowData)}
        //             />
        // }

        const renderLancamentosTable = () => {
            if(this.state.isDoingLancamentos)
                return (
                    <div >
                    <DataTable  
                        // value={this.state.lancamentos}
                        value={this.filterLancamentos()}
                        // size="small"
                        className="p-datatable-sm small-font"
                        editMode="cell"
                        dataKey="id"
                        loading={this.state.loading}
                        // onRowEditComplete={this.onRowEditComplete1}
                        responsiveLayout="scroll"
                        emptyMessage="Nenhum tipo de recebimento encontrado."
                    >
                
                    <Column
                        field="nomeTipoDeRecebimento" header="Nome"
                        body={rowData => 
                            <CustomHighlighter
                                searchWords={[this.state.searchText]}
                                textToHighlight={rowData.nomeTipoDeRecebimento}
                            />
                        } 
                    />
                    
                    <Column 
                        field="valor" header="Valor"
                        body={rowData => GeneralServices.valueBodyTemplate(rowData.valor)}
                        // editor={(options) => valueEditor(options)}
                        editor={(options) => {
                            return GeneralServices.inputTableNumber(
                                options.rowData.id,
                                options.rowData.nomeTipoDeRecebimento,
                                options.rowData.valor,
                                options.rowData,
                                this.handleTableChange,
                                "Valor",
                                false,
                                this.onLostFocus,
                                this.onKeyDown
                            )
                        }}
                    />

                    <Column
                        header="Cancelar"
                        body={cancelLancamnetoTemplate}
                    />
                    
                </DataTable>
                </div>
                )
        }

        const renderInfoButton = (lancamento) => {
            if(lancamento.idLancamentoImportacao)
                return (
                    <div
                        className='right-button'
                    >
                        <TooltipButton 
                            tooltip={`Este lançamento foi importado automaticamente pelo sistema.\n
                                Para confirmá-lo, basta salvar os lançamentos no botão ao final da página.`}
                                tooltipOptions={{
                                    className: 'custom-tooltip',
                                    // position: 'left'
                                }}                        
                            icon={<i className="pi pi-question p-mr-3" style={{ fontSize: '1rem'}} />}
                            className="p-button-rounded p-mr-2"
                        />
                    </div>
                )
        }

        const cancelLancamnetoTemplate = (lancamento) => {
            if(lancamento.lancamentoJaRealizado){
                return (
                    <div className='row'>
                        <TooltipButton 
                            tooltip='Voltar ao valor inicial'
                            icon="pi pi-times"
                            className="p-button-rounded p-button-danger p-mr-2"
                            onClick={ () => this.cancelLancamentoLine(lancamento) }
                        />
                        {renderInfoButton(lancamento)}
                    </div>
                )
            }
        }

        const renderButtons = () => {
            if(this.situacaoInicial()){
                return (
                    <>
                    
                    <Button 
                    label="Fazer Lançamentos"
                    icon="pi pi-pencil"
                    onClick = {this.callLancamento}
                    />

                    <br />

                    <br />

                    </>
                )
            } else {
                return(
                    <div>
                    <Button 
                        label="Salvar Lançamentos"
                        icon="pi pi-save"
                        onClick = {this.save}
                        disabled = {this.state.isSavingLancamentos}
                    />

                    <Button 
                    label="Voltar"
                    icon="pi pi-undo"
                    className="p-button-danger right-button"
                    onClick = {this.cancelLacamentos}
                    disabled = {this.state.isSavingLancamentos}
                    />
                    </div>
                )
                
            }
        }

        const renderResumoTotal = () => {
            if(this.state.isDoingLancamentos)
            return(
                <>
                <div className = "card-header">
                <div className = "row">
                    <div className="col-md-3">
                            <Button 
                                label={'Total Lançado: ' + GeneralServices.valueBodyTemplate(this.state.totalLancado) }
                                className=" small-font p-button-success"
                                // style={ {maxHeight: '25px' } }
                                onClick={() => {this.copyValue(this.state.totalLancado)}}
                            />
                    </div>
                    <div className="col-md-3">
                        <div className='row'>
                            <div className="input-group mb-3">
                                <span className="p-inputgroup-addon medium-font-size">PDV:</span>
                                <InputNumber 
                                    name="pdvLancamento"
                                    inputId="currency-us"
                                    value={this.state.pdvLancamento}
                                    onValueChange={this.handlePdvLancamentoChange}
                                    mode="currency" currency="BRL" locale="pt-BR" 
                                />
                                <Button
                                    icon={<i className="pi pi-question" style={{fontSize: '0.8em'}}></i>}
                                    className="p-button-rounded p-mr-2 medium-font"
                                    style={ {display: this.state.selectedTipoDeRecebimentoValue === '' ? 'none' : '',
                                        marginLeft: '3px', maxHeight: '25px', maxWidth: '25px'}}
                                    display={false}
                                    tooltip={"Ponto De Venda." + "\n" + "O valor total informado pelo frente de loja."}
                                    tooltipOptions={{position: 'top'}}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <Button 
                            label={'Diferença: ' + GeneralServices.valueBodyTemplate(this.calculateDiferenca()) }
                            className={`${this.getClassNameButtonDiferenca()} small-font`}
                            onClick={() => {this.copyValue(this.calculateDiferenca())}}
                        />
                    </div>
                    <div className="col-md-3">
                        <AnotacoesComponent
                            recurso = {this.montaRecursoAnotacao()}
                        />
                    </div>
                    </div>
                    </div>


                <br />
                </>
            )
        }

        const renderImportacaoDialog = () => {
            return (
                <Dialog
                    visible={this.state.displayImportacaoDialog}
                    style={{ maxHeight: '95vh', width: '85vw'}}
                    modal
                    className="p-fluid"
                    baseZIndex={-1}
                    // footer={uploadDialogFooter}
                    onHide={this.hideDialog}
                >
                    <div className="p-field">
                    <Card
                        title = {"Importação de Lançamentos de Caixa"}
                        // rightComponent={renderRightTooltipButton()}
                    >
                        <FileUploadCard
                            // uploadInProgress = {this.setIfIsInProgress}
                            accept=".xls, .xlsx, .csv"
                            uploadDescription={ConstantsUtil.importacaoLancamentosCaixa}
                            // onFinish={this.onFinishUpload}
                        />
                    </Card>
                    </div>
    
                </Dialog>
            )
        }

        const renderRightButton = () => {
            if(this.situacaoInicial()){
                return renderImportacaoButton()
            }
            else{
                return renderPesquisaValorButton()
            }
        }

        const renderImportacaoButton = () => {
            return (
                <Button 
                    label="Importar Lançamentos"
                    className="p-button-success"
                    icon="pi pi-upload"
                    onClick = {() => this.setState({displayImportacaoDialog: true})}
                    // disabled={!this.state.habilitaBusca}
                />
            )
        }

        const renderPesquisaValorButton = () => {
            return (
                <div className='row'>
                <div className='col-md-8'>
                <input style={{color: '#000'}}
                    // autoFocus
                    className={"form-control " }
                    type="text"
                    id="searchText"
                    name="searchText"
                    value={this.state.searchText}
                    placeholder="Pesquise pelo nome"
                    onChange = {this.handleChange}
                    // onKeyPress={this.handleKeyPress}
                    disabled={!this.state.isDoingLancamentos}
                />
                </div>
                <div className='col-md-2'>
                    <TooltipButton
                        tooltip="Limpar Pesquisa"
                        icon="pi pi-times"
                        className="p-button-rounded p-button-danger p-mr-2"
                        onClick={this.limparPesquisa}
                        disabled={!this.state.isDoingLancamentos}
                    />
                </div>
                <div className='col-md-2'>
                </div>
                </div>
            )
        }

    return (
        <div className="bs-docs-section" >
            <Card title = "Lançar Fechamento de Caixa"
                rightComponent={renderRightButton()}
            >
                <div className="col-md-12">
                    
                    <div className = "row">
                        
                        <div className="col-md-2">

                        <div className="row">
                            
                        {/* <div className="col-md-4"> */}
                            {/* <span className="p-float-label"> */}
                            {/* <label htmlFor="icon">Data do Lançamento</label> */}
                            <CustomCalendar
                                id="dataLancamentoFechamentoCaixa"
                                htmlFor="icon"
                                label="Data do Lançamento"
                                inputDateErrorClass={this.state.inputDateErrorClass}
                                value={this.state.dataLancamentoView}
                                name="dataLancamento"
                                onChange={this.handleDateChange}
                                disabled={this.state.isDoingLancamentos}
                                errorDateMessage={this.state.errorDateMessage}
                                noHTMLFormat
                                // style={{minWidth:'490px'}}
                                // showIcon
                                // showButtonBar
                                // locale="pt-BR"
                                // dateFormat="dd/mm/yy"
                                // yearRange={GeneralServices.yearRange()}
                                // monthNavigator yearNavigator
                                // monthNavigatorTemplate={monthNavigatorTemplate}
                                // yearNavigatorTemplate={yearNavigatorTemplate}
                            />
                            </div>
                            {/* <div className="row">
                            <small id="dateErrorNotice" className="p-error">{this.state.errorDateMessage}</small>

                            </div> */}
                            {/* </span> */}
                        {/* </div> */}

                        <br />

                        <div className="row">
                        <PDVCaixaInput
                            ref={this.pdvCaixaInputRef}
                            selectedPdvCaixaId={this.state.selectedPdvCaixaId}
                            handleChange={this.handleChange}
                            inputPdvCaixaErrorClass={this.state.inputPdvCaixaErrorClass}
                            disabled={this.state.isDoingLancamentos}
                        />
                        </div>

                        <br />

                        <div className="row">
                        <label htmlFor="icon">Turno</label>
                        <SelectMenu
                            className={"form-control " + this.state.inputTurnoErrorClass}
                            name="selectedTurno"
                            list={this.lancamentoFechamentoCaixaService.turnoArray} 
                            value={this.state.selectedTurno}
                            onChange={this.handleChange}
                            disabled={this.state.isDoingLancamentos}
                        /> 
                        <div className="invalid-feedback">{ConstantsUtil.errorTurnoMessage}</div>  
                        </div>

                        <br />

                        </div>
                        
                        <div className="col-md-1"> 
                        {/* div vazia. Objetivo apenas de ocupar as 3 primeiras colunas */}
                        </div>

                        <div className="col-md-9">
                            {renderLancamentosTable()}
                        </div>
                    </div>

                    <br />

                    <div className = "row">
                        <div className="col-md-3"> 
                        {/* div vazia. Objetivo apenas de ocupar as 3 primeiras colunas */}
                        </div>
                        <div className="col-md-9">
                        {renderResumoTotal()}
                        </div>
                        
                    </div>

                </div>

                <div className="row">
                    <div className="col-md-6"> 
                        {renderButtons()}
                    </div>
                </div>

                {renderImportacaoDialog()}
                
            </Card>
            <div className="d-flex "/>
        </div>              
    )
    }


}

LancarFechamentoDeCaixa.contextType = AuthContext

export default withRouter(LancarFechamentoDeCaixa)